module.exports = __webpack_public_path__ + "assets/media/GIF-Failure@2x.f3f3d528.png";